import React from 'react';
import Logo from "../../assets/logo.png";
import {
    InboxIcon,
    PhoneIcon,
    LocationMarkerIcon,
    LoginIcon,
    UsersIcon,
    LinkIcon,
} from "@heroicons/react/outline";
import css from './Footer.module.css';

const Footer = () => {
  return (
    <div className={css.cFooterWrapper}>
       <hr/>

       <div className={css.cFooter}>
          <div className={css.logo}>
             <img src={Logo} alt="" />
             <span>amazon</span>
          </div>

          <div className={css.block}>
             <div className={css.detail}>
                <span>Contact US</span>
                <span className={css.pngLine}>
                   <LocationMarkerIcon className={css.icon}/>
                   <span>Botamical Garden , near metro , Delhi ,India </span>
                </span>

                <span className={css.pngLine}>
                  {" "}
                  <PhoneIcon className={css.icon1}/>
                  <a href="tel:+91-8172802284">8172802284</a>
                </span>

                <span className={css.pngLine}>
                  <InboxIcon className={css.icon1}/>
                  <a href="mailto:ok5400@gmail.com">ok5400@gmail.com</a>
                </span>
             </div>
          </div>

          <div className={css.block}>
             <div className={css.detail}>
                <span>Account</span>
                <span className={css.pngLine}>
                   <LoginIcon className={css.icon1}/>
                   Sign In
                </span>
             </div>
          </div>


          <div className={css.block}>
             <div className={css.detail}>
                <span>Company</span>
                <span className={css.pngLine}>
                   <UsersIcon className={css.icon1}/>
                   <a href='/about'>
                    <p>About us</p>
                   </a>
                </span>
             </div>
          </div>

          <div className={css.block}>
             <div className={css.detail}>
                <span>Resources</span>
                <span className={css.pngLine}>
                   <LinkIcon className={css.icon1}/>
                   <p>Safety Privacy & Terms</p>
                </span>
             </div>
          </div>
       </div>

       <div className={css.copyRight}>
         <span>Copyright @2023 by OsamaKhan, Inc.</span>
         <span>All right reserved.</span>
       </div>
    </div>
  );
};

export default Footer;